import React, { useCallback, useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import printJS from 'print-js';
import { useSelector } from '@xstate/react';
import { Anchor, Button, Card, Loader } from '@chargify/custom-ui-components';
import { useToastMessages } from '@chargify/toasts';
import { DataAccessContext } from '@chargify/data-access';

import { GlobalStateContext } from '../../contexts';
import { billingHistorySelectors } from '../../machines/billingHistoryData';
import {
  LoaderWrapper,
  StyledIframe,
  Wrapper,
  HeaderWrapper,
  ActionButtonsWrapper,
} from './InvoiceDetails.styles';

const InvoiceDetails = () => {
  const { t } = useTranslation('billing-history');
  const toastsService = useToastMessages();

  const navigate = useNavigate();
  const { invoiceId } = useParams();
  const { billingHistoryDataService } = useContext(GlobalStateContext);
  const { dataAccess } = useContext(DataAccessContext);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const [printInvoiceLoading, setPrintInvoiceLoading] = useState(false);

  const showErrorToast = () => {
    toastsService.show({
      level: 'warning',
      message: t('invoice_details.an_error_occurred_please_try_again_later'),
    });
  };

  const [invoice] = useSelector(
    billingHistoryDataService,
    useCallback(billingHistorySelectors.getBillingItemById(invoiceId), [])
  );

  const printInvoice = () => {
    setPrintInvoiceLoading(true);
    dataAccess
      .getInvoicePDF(invoice.id)
      .then((blob) => {
        const fileURL = URL.createObjectURL(
          new Blob([blob], { type: 'application/pdf' })
        );
        printJS(fileURL);
      })
      .catch((_e) => showErrorToast())
      .finally(() => setPrintInvoiceLoading(false));
  };

  return (
    <>
      <Card>
        <Card.Header>
          <HeaderWrapper>
            <Anchor
              label={t('invoice_details.back_to_invoice_list')}
              iconLeft="chevronLeft"
              onClick={() => navigate('/')}
            />
            <ActionButtonsWrapper>
              <Button
                label={t('invoice_details.print_an_invoice')}
                color="secondary"
                onClick={printInvoice}
                isLoading={printInvoiceLoading}
              />
            </ActionButtonsWrapper>
          </HeaderWrapper>
        </Card.Header>
        <Wrapper>
          {!iframeLoaded && (
            <LoaderWrapper>
              <Loader />
            </LoaderWrapper>
          )}
          <StyledIframe
            src={invoice.invoiceUrl}
            onLoad={() => setIframeLoaded(true)}
          ></StyledIframe>
        </Wrapper>
      </Card>
    </>
  );
};

export default InvoiceDetails;
